import {
  BaseContainer,
  BaseAvatar,
  Notification,
  Presence,
  BaseGroupAction,
  BaseAvatarGroup,
} from "./styles"

interface Props extends React.ComponentPropsWithoutRef<"img"> {
  size?: "small" | "default" | "large" | "xlarge"
  type?: "circle" | "square"
}

interface IAvatar extends React.FC<Props> {
  Notification: React.FC<React.ComponentPropsWithoutRef<"span">>
  Presence: React.FC<React.ComponentPropsWithoutRef<"span">>
}

const Avatar: IAvatar = ({
  size = "default",
  type = "circle",
  className = "",
  children,
  ...props
}) => {
  return (
    <BaseContainer className={`size--${size} type--${type} ${className}`}>
      {props.src && <BaseAvatar {...props} />}

      {children}
    </BaseContainer>
  )
}

Avatar.Notification = ({ className, ...props }) => (
  <Notification className={`small-heavy ${className}`} {...props} />
)
Avatar.Notification.displayName = "AvatarNotification"

Avatar.Presence = Presence
Avatar.Presence.displayName = "AvatarPresence"

interface IAvatarGroup extends React.FC {
  Action: React.FC<
    React.ComponentPropsWithoutRef<"button"> & {
      size?: "small" | "default" | "large" | "xlarge"
    }
  >
}

const AvatarGroup: IAvatarGroup = (props) => <BaseAvatarGroup {...props} />

AvatarGroup.Action = ({ children, size = "default", className, ...props }) => {
  return (
    <BaseGroupAction {...props}>
      <Avatar className={className} size={size}>
        {children}
      </Avatar>
    </BaseGroupAction>
  )
}
AvatarGroup.Action.displayName = "AvatarGroupAction"

export { Avatar, AvatarGroup }
